export const headerSupplierJobsStyle = (theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
});
